module.exports = __webpack_public_path__ + "img/文体活动.e63ff050.jpg";